import {useReducer} from 'react'
import {Action, ProtectPlusAction, State} from './types'
import moment from 'moment'

const reducer = (state: State, action: ProtectPlusAction): State => {
	const {type} = action
	switch (type) {
		case Action.quoteError:
			return {...state, quoteError: action.value}
		case Action.saleComplete:
			return {...state, saleError: null, saleResponse: action.value}
		case Action.saleError:
			return {...state, saleError: action.value}
		case Action.saleInProgress:
			return {...state, saleInProgress: action.value}
		case Action.updateQuoteData:
			return {...state, quoteData: action.value, saleResponse: null}
		default:
			return state
	}
}

export const useProtectPlusReducer = () => {
	const initialState: State = {
		quoteData: {
			eventTravelDateTime: moment().add(1, 'd').format('DD/MM/YYYY'),
			flights: [
				{
					arrivalCode: 'LBA',
					departureCode: 'LHR',
					departureDate: moment().add(1, 'd').format('DD/MM/YYYY'),
					class: 'economy',
					flightNumber: 'AA1'
				}
			],
			numberOfTickets: 1,
			totalValue: 10
		},
		quoteError: null,
		saleError: null,
		saleResponse: null,
		saleInProgress: false
	}
	return useReducer(reducer, initialState)
}
